import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { error, failedResponse, getBackendUrl, loaded, loading, LoadState, LoadStateInfo, notStarted } from "../../common";

export interface MessageDismissed {
	id: number,
	messageId: number,
	conversationMessageId: number,
	userId: number,
}

export interface MessageDismissedRequest {
    messageId?: number;
}

export const retrieveMessageDismissed = createAsyncThunk(
    "retrieveMessageDismissed",
    async (param: MessageDismissedRequest, thunkAPI) => {
        console.debug("retrieve message dismissed");

        const token = (thunkAPI.getState() as RootState).user.token;

        const response = await fetch(`${getBackendUrl()}/api/conversation/massive/message/dismissed/${param.messageId}`, {
            signal: thunkAPI.signal,
            headers: {
                "Authorization": `Bearer ${token}`,
            }
        });

        if (response.ok) {
            return await response.json();
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    },
    {
        condition: (param, { getState }) => {
            const state = getState() as RootState;
            if(! state.user.token) {
                console.debug("No token, not loading message dismissed");
                return false;
            }
            if (state.messageDismissed.state.state === LoadState.NotStarted) {
                // Only load if never loaded before
                return true; 
            }
            return false;
        },
    }
);

export interface MessageDismissedState {
    state: LoadStateInfo;
    request?: MessageDismissedRequest;
    list?: MessageDismissed[];
}

const initialState: MessageDismissedState = {
    state: notStarted(),
};

export const messageDismissedSlice = createSlice({
    name: "messageDismissed",
    initialState,
    reducers: {
        clean: (state) => {
            state.state = notStarted();
            state.request = undefined;
            state.list = undefined;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(retrieveMessageDismissed.pending, (state, action) => {
                state.state = loading();
                state.request = action.meta.arg;
                state.list = undefined;
            })
            .addCase(retrieveMessageDismissed.fulfilled, (state, action) => {
                state.state = loaded();
                state.list = action.payload;
            })
            .addCase(retrieveMessageDismissed.rejected, (state, action) => {
                state.state = error(action);
            });
    },
});

// export const { } = conversationListSlice.actions;

export const selectMessageDismissed = (state: RootState) => state.messageDismissed;

export default messageDismissedSlice.reducer;
